// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchPanel_wrapper_a1865","title":"SearchPanel_title_ff62b"};